import React from 'react';
import { message } from 'antd';
import { ModalAttendance } from '../../../../components/ModalAttendance';

import { deletarConsulta } from '../../../../services/cadastroConsulta';

export function ModalExclusao({
  isModalVisible,
  setIsModalVisible,
  consulta,
  setReloadGrid,
  reloadGrid,
}) {
  const handlerDeleteConsult = async id => {
    try {
      const response = await deletarConsulta(id);
      if (response?.status === 200) {
        message.success(response?.data || '');
        setReloadGrid(!reloadGrid);
      }
    } catch (err) {
      if (err) {
        message.error(err.response.data.detail);
      }
    }

    setIsModalVisible(false);
  };

  const cancelModal = () => setIsModalVisible(!isModalVisible);

  const okModal = () => {
    setIsModalVisible(!isModalVisible);
    handlerDeleteConsult(consulta);
  };

  return (
    <ModalAttendance
      title="Deseja excluir a Consulta?"
      visible={isModalVisible}
      cancelBtn={cancelModal}
      okBtn={okModal}
    />
  );
}
